import useGeneralLoader from "./useGeneralLoader";

export const useProfilePicLoader = (accountUID) => {
    return useGeneralLoader(`profile-pic-${accountUID}`, `api/accounts/${accountUID}/profile/pic/download/url`, 'profilePicURL', 'url');
};